import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("token"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

export const getDashboradChartsDetails = async (
    product,
    tenant,
    dateRange,
    startDate,
    endDate
) => {
    const authToken = getAuthToken();
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/dashboardCharts/data`, {
                headers: headers,
                params: {
                    product,
                    tenant,
                    dateRange,
                    startDate,
                    endDate
                },
            })
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                console.log("new error ", error);
                reject(error);
            });
    })
}


export const getRecentTransactionsAction = (
    startDate,
    endDate
) => {
    const authToken = getAuthToken();

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    return new Promise((resolve, reject) => {
        axios
            .get(
                `/api/dashboardCharts/recent-transactions`,
                {
                    headers,
                    params: {
                        startDate,
                        endDate,
                    },
                }
            )
            .then((response) => {
                resolve(response?.data);
            })
            .catch((error) => {
                console.log(
                    "Recent transactions error",
                    error
                );

                reject(error);
            });
    });
};